const currentSite = process.env.REACT_APP_BUILD_SITE;

const siteByName = {
  UBPE: 'Urbania',
  ZPAR: 'Zonaprop',
  WIBR: 'Wimoveis',
  IWBR: 'Imovelweb',
  DVPE: 'Adondevivir',
  '24MX': 'Inmuebles24',
  CMBR: 'Casamineira',
  VAMX: 'Vivanuncios',
  PLEC: 'Plusvalia',
  CAPA: 'Compreoalquile'
};

const domainBySite = {
  UBPE: 'urbania.pe',
  ZPAR: 'zonaprop.com.ar',
  WIBR: 'wimoveis.com.br',
  IWBR: 'imovelweb.com.br',
  DVPE: 'adondevivir.com',
  '24MX': 'inmuebles24.com',
  CMBR: 'casamineira.com.br',
  VAMX: 'vivanuncios.com.mx',
  PLEC: 'plusvalia.com',
  CAPA: 'compreoalquile.com'
};

const classNameBySite = {
  UBPE: 'URB',
  ZPAR: 'DEFAULT',
  WIBR: 'DEFAULT',
  IWBR: 'DEFAULT',
  DVPE: 'DEFAULT',
  CAPA: 'DEFAULT',
  PLEC: 'DEFAULT',
  '24MX': 'DEFAULT',
  CMBR: 'CMBR',
  VAMX: 'VAMX'
};

export const getSiteName = () => {
  return siteByName[currentSite];
};

export const getSiteDomain = () => {
  return domainBySite[currentSite];
};

export const getClassNameBySite = () => {
  return classNameBySite[currentSite];
};
